"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalLeaderBoard = void 0;
exports.externalLeaderBoard = {
    isEnable: false,
    componentStyle: {
        backgroundColor: '2D63A8',
        borderRadius: '0px',
        padding: '0px',
    },
    evenRowStyle: {
        backgroundColor: '3aaf8a',
        color: 'FFFFFF',
        fontSize: '18px',
        borderRadius: '0px',
    },
    oddRowStyle: {
        backgroundColor: '2D63A8',
        color: 'FFFFFF',
        fontSize: '18px',
        borderRadius: '0px',
    },
    titleText: 'LEADERBOARD',
    titleTextStyle: {
        color: 'FFFFFF',
        fontSize: '26px',
        textAlign: 'center',
        top: '5%',
    },
    backgroundImageUrl: 'https://prod-cdn.flarie.com/asset/game-center/website-bg.png',
    topImageUrl: 'https://prod-cdn.flarie.com/asset/games/external_leaderboard_top_image.png',
    descriptionText: '',
    descriptionTextStyle: {
        color: 'FFFFFF',
        fontSize: '18px',
        textAlign: 'center',
    },
    pointTextStyle: {
        color: 'FFFFFF',
        fontSize: '18px',
    },
    font: 'bebas',
};
